const countryCode = (state = null) => state;

export default countryCode;



// WEBPACK FOOTER //
// ./app/src/state/reducers/countryCode.js